import { render, staticRenderFns } from "./inactive-profile-bar.vue?vue&type=template&id=013b9a55"
import script from "./inactive-profile-bar.vue?vue&type=script&lang=js"
export * from "./inactive-profile-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports